import React from 'react';

import UnauthorizedPageHeader from '@app/layouts/UnauthorizedPageLayout/header';
import { RootGrid, unauthorizedLayoutClasses } from '@app/layouts/UnauthorizedPageLayout/styles';

import { Box, Grid, Hidden, Typography } from '@mui/material';

import * as environment from '@utils/environment';

import { FIRM_NAME_MAP } from './constants';

function UnauthorizedPageLayout({
	isPostLogin,
	children,
	fullPage,
}: {
	children: React.ReactNode;
	isPostLogin?: boolean;
	fullPage?: boolean;
}) {
	if (fullPage) {
		return (
			<RootGrid container>
				<Grid item xs={12} className={unauthorizedLayoutClasses.rightContainer}>
					<UnauthorizedPageHeader />
					<Box className={unauthorizedLayoutClasses.terms}>{children}</Box>
				</Grid>
			</RootGrid>
		);
	}
	return (
		<RootGrid container>
			<Hidden mdDown>
				<Grid item md={6} className={unauthorizedLayoutClasses.leftContainer}>
					{environment.env.FIRM_ENVIRONMENT !== 'bosonic' && environment.env.FIRM_ENVIRONMENT !== 'secondlane' && (
						<Box pl={10} sx={{ maxWidth: 600 }}>
							{process.env.FIRM_ENVIRONMENT !== 'york' && (
								<Typography variant="h4" mt={3}>
									<b>From Vision to Reality</b>
								</Typography>
							)}

							<Typography
								variant="subtitle1"
								mt={4}
								sx={{ fontSize: process.env.FIRM_ENVIRONMENT === 'york' ? '18px' : 'auto' }}
							>
								{`Ignite your future with ${FIRM_NAME_MAP.get(
									environment.env.FIRM_ENVIRONMENT,
								)}. Unlock your financial power with an investment account that realizes
							your goals.`}
							</Typography>
						</Box>
					)}
				</Grid>
			</Hidden>

			<Grid item xs={12} md={6} className={unauthorizedLayoutClasses.rightContainer}>
				<UnauthorizedPageHeader isPostLogin={isPostLogin} />

				<Box className={unauthorizedLayoutClasses.form}>{children}</Box>
			</Grid>
		</RootGrid>
	);
}

export default UnauthorizedPageLayout;
